export default __webpack_public_path__ + "static/media/fd1.3a175029.jpg";